import { Component, EventEmitter } from '@angular/core';
import { first } from 'rxjs/operators';
import { County } from '../../foundation/models/enums/county.enum';
import { Jurisdiction } from '../../foundation/models/enums/jurisdiction.enum';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerAccountDetail } from '../models/customer-account-detail.model';
import { CustomerAddress } from '../models/customer-address.model';
import { ContactMethodType } from '../models/enums/contact-method-type.enum';
import { CustomerAccountStatusType } from '../models/enums/customer-account-status-type.enum';
import { CustomerAccountService } from './service/customer-account.service';

@Component({
    selector: 'edit-customer-account',
    templateUrl: './edit-customer-account.html',
    outputs: ['navigateBack'],
    inputs: ['customerAccountNumber']
})
export class EditCustomerAccountComponent extends BaseComponent {
    public navigateBack: EventEmitter<any> = new EventEmitter<any>();
    public customerAccountNumber: number;
    public customerAccount: any;
    public stateEnum = new Jurisdiction();
    public contactMethodEnum = new ContactMethodType();
    public counties = new County();
    public states = new Jurisdiction();
    public customerAccountStatus = new CustomerAccountStatusType().GetActive();
    public personalEmail: any;
    public personalCellPhone: any;
    public otherContacts: any;
    public statusId: number;
    public showButtonLoading = false;
    public correspondenceContactTypes: any[];

    private customerAccountStatusEnum = new CustomerAccountStatusType();

    constructor(private customerAccountService: CustomerAccountService) {
        super();
        this.correspondenceContactTypes = [this.contactMethodEnum.AlternativeEmail.id, this.contactMethodEnum.BusinessEmail.id, this.contactMethodEnum.PersonalEmail.id, this.contactMethodEnum.BusinessCell.id, this.contactMethodEnum.PersonalCell.id];
    }

    async ngOnInit() {
        this.UseHelpContent('#CONTENT/AZ_MVD_Now/Edit_Customer_Account.htm%3FTocPath%3DAZ%2520MVD%2520Now%7C_____6');

        this.customerAccount = await this.customerAccountService.getCustomerAccountDetails(this.customerAccountNumber).pipe(first()).toPromise();

        if (this.customerAccount.accountAddress && (this.customerAccount.accountAddress.jurisdictionId == null || this.customerAccount.accountAddress.jurisdictionId == 0)) {
            this.customerAccount.accountAddress.jurisdictionId = this.stateEnum.AZ.id;
        }

        if (!this.customerAccount.accountAddress) {
            this.customerAccount.accountAddress = new CustomerAddress();
            this.customerAccount.accountAddress.jurisdictionId = new Jurisdiction().AZ.id;
        }

        this.personalEmail = this.customerAccount.accountContacts.find(x => x.contactMethodTypeID == this.contactMethodEnum.PersonalEmail.id) || { contactMethodTypeID: this.contactMethodEnum.PersonalEmail.id, customerContactValue: null, isCorrespondenceEnabled: false, customerAccountNumberId: this.customerAccountNumber };
        this.personalCellPhone = this.customerAccount.accountContacts.find(x => x.contactMethodTypeID == this.contactMethodEnum.PersonalCell.id) || { contactMethodTypeID: this.contactMethodEnum.PersonalCell.id, customerContactValue: null, isCorrespondenceEnabled: false, customerAccountNumberId: this.customerAccountNumber };

        this.otherContacts = this.customerAccount.accountContacts.filter(x => x.contactMethodTypeID != this.contactMethodEnum.PersonalEmail.id && x.contactMethodTypeID != this.contactMethodEnum.PersonalCell.id);

        if (this.customerAccount.accountStatus) {
            const statusValue =  this.customerAccountStatusEnum.FromValue(this.customerAccount.accountStatus);
            this.statusId = statusValue ? statusValue.id : null;
        }
    }

    public getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            var type = types.FromId(id);

            if (type !== undefined) {
                return type.displayValue;
            }
        } else {
            return '';
        }
    }

    async save() {
        try {
            this.showButtonLoading = true;

            // Append customer account number ID to account address
            this.customerAccount.accountAddress.customerAccountNumberId = this.customerAccountNumber;

            // Collect contact data
            if (this.personalEmail.customerContactId || this.personalEmail.customerContactValue) {
                await this.customerAccountService.saveAccountContact(this.personalEmail).pipe(first()).toPromise();
            }

            if (this.personalCellPhone.customerContactId || this.personalCellPhone.customerContactValue) {
                await this.customerAccountService.saveAccountContact(this.personalCellPhone).pipe(first()).toPromise();
            }

            for (let i = 0; i < this.otherContacts.length; i++) {
                if (this.otherContacts[i].customerContactId || this.otherContacts[i].customerContactValue) {
                    await this.customerAccountService.saveAccountContact(this.otherContacts[i]).pipe(first()).toPromise();
                }
            }

            await this.customerAccountService.saveAccountProperties({ nickname: this.customerAccount.accountName, customerAccountNumberId: this.customerAccount.customerAccountNumberId, description: this.customerAccount.accountDescription }).pipe(first()).toPromise();

            var navigateBack = true;
            try {
                await this.customerAccountService.saveAccountStatus({ customerAccountNumberId: this.customerAccount.customerAccountNumberId, CustomerAccountStatusTypeId: this.statusId }).pipe(first()).toPromise();
            } catch (err) {
                navigateBack = false;
                this.handleValidationResult(err);
            }

            this.showButtonLoading = false;

            if (navigateBack) {
                this.navigateBack.emit();
            }
        } catch (err) {
            if (err.validationResults) {
                this.handleValidationResult(err);
                this.showButtonLoading = false;
            } else {
                throw err;
            }
        }
    }

    cancel() {
        this.navigateBack.emit();
    }
}
